import { describeStrip } from './strip';
import { strip, type StripState } from './tokens';

export interface UptimeStripProps {
  /** One state per day, oldest first. */
  days: StripState[];
  height?: number;
}

/** Row of day bars coloured by state, as on the deployment cards. */
export function UptimeStrip({ days, height = 24 }: UptimeStripProps) {
  return (
    <div role="img" aria-label={describeStrip(days)} style={{ display: 'flex', gap: 2, height }}>
      {days.map((d, i) => (
        <span key={i} data-state={d} style={{ flex: 1, borderRadius: 2, background: strip[d] }} />
      ))}
    </div>
  );
}
